/* eslint-disable @typescript-eslint/no-explicit-any */
import { InternalLinkTool } from "@/components/EditorJs/plugins/InternalLinkTool";
import { AssetsService } from "@/services/admin-services";
import { LogLevels } from "@/utils/Utils";
import EditorJS, { OutputData } from "@editorjs/editorjs";
import Embed from "@editorjs/embed";
import Image from "@editorjs/image";
import List from "@editorjs/list";
import Marker from "@editorjs/marker";
import Underline from "@editorjs/underline";
import { Paper } from "@mui/material";
import { nanoid } from "nanoid";
import { useEffect, useRef, useState } from "react";
import { BlockEditorProps } from "../../Models";

const BlockContentEditor = ({ data, elements, section, onChange }: BlockEditorProps) => {
    const [id, setId] = useState<string>();
    const [editorData, setEditorData] = useState<OutputData | undefined>(data);
    const editorRef = useRef<EditorJS>();
    const assetsService = new AssetsService();

    useEffect(() => {
        setId(`${section.sectionCode}-${nanoid()}`);

        return () => {
            const editor = editorRef.current;
            if (editor) {
                if (!editor) return;
                editor.isReady.then(() => editor.destroy());
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (id) initEditor();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const initEditor = () => {
        const editor: EditorJS = new EditorJS({
            autofocus: false,
            logLevel: LogLevels.ERROR,
            holder: id,
            data: editorData,
            onChange: async (api) => {
                const content = await api.saver.save();

                setEditorData(content);
                onChange(content);
            },
            inlineToolbar: ["bold", "italic", "underline", "marker", "internalLink"],
            tools: {
                image: {
                    class: Image,
                    inlineToolbar: true,
                    config: {
                        types: "image/jpeg, image/jpg, image/png, image/gif, video/mp4, video/quicktime",
                        field: "media",
                        uploader: {
                            uploadByFile: async (blob: any) => {
                                const form = new FormData();
                                form.append("File", blob);

                                return await assetsService.create(form);
                            },
                            uploadByUrl: (bt: any) => new Promise((f) => f({ success: 1, file: { url: bt } })),
                        },
                    },
                },
                underline: Underline,
                list: { class: List, inlineToolbar: true },
                embed: Embed,
                marker: { class: Marker },
                internalLink: {
                    class: InternalLinkTool,
                    inlineToolbar: true,
                    config: {
                        elements,
                    },
                },
            },
        });

        editorRef.current = editor;
    };

    return id ? (
        <Paper id={id} className="element-page-editor" sx={{ m: 1, mb: 2, position: "relative" }}></Paper>
    ) : null;
};

export default BlockContentEditor;
